<template>
  <div :class="mold">
    <template v-for="(item, index) in datas">
      <!-- 自定义类型 -->
      <div v-if="item.type === 'attribute'">
        <div class="row" :class="[align]" v-for="(value, sindex) in item.value">
          <div class="label" v-text="value.key"></div>
          <div class="value" v-text="value.value"></div>
        </div>
      </div>

      <!-- 普通类型 -->
      <div class="row" :class="[align]" v-else>
        <div class="label" v-text="item.label"></div>
        <div class="value" v-text="item.value"></div>
      </div>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'Form',
    props:{
      datas: {
        type: Object,
        default: {}
      },
      mold: {
        type: String,
        default: 'Alsace'
      },
      align: {
        type: String,
        default: 'left'
      }
    }
  }
</script>

<style scoped lang="scss">
/* 公公样式 */
.right{
  text-align: right;
}

/* 表单样式 — 阿尔萨斯 */
.Alsace{
  .row{
  	padding: 15px 0;
    font-size: 1em;
  	display: flex;
    line-height: 1.5em;
  	border-bottom: 1px solid #f4f5f7;
    &:last-child{
      border-bottom: 0;
    }
    .label{
    	padding-right: 20px;
    	position: relative;
    	display: flex;
    	margin: auto;
      color: #555;
    }
    .label::after{
    	content: "";
    	display: block;
    	position: absolute;
    	right: -5px;
    	top: 50%;
    	width: 0;
    	height: 0;
    	border: 6px solid;
    	transform: translateY(-50%);
    	border-color: rgba(0,0,0,0) rgba(0,0,0,0) rgba(0,0,0,0) #eee;
    }
    .value{
    	flex: 1;
    	padding-left: 3px;
    }
  }
}


/* 表单样式 - 伊利丹怒风 */
.IllidanStormrage{
  .row{
    line-height: 28px;
    padding-top: 10px;
    font-size: 1em;
    .label{
      display: inline;
      padding-right: 20px;
    }
    .value{
      display: inline;
      color: #555;
      text-align: center;
    }
  }
}

/* 表单样式 - 古尔丹 */
.Guldan{
  .row{
    display: flex;
    line-height: 28px;
    padding-top: 10px;
    font-size: 1em;
    .label{
      width: 80px;
      color: #555;
      padding-right: 20px;
    }
    .value{
      width: calc(100% - 100px);
    }
  }
}

/* 表单样式 - 瓦里安·乌瑞恩 */
.VarianWrynn{
  .row{
    display: flex;
    line-height: 28px;
    padding-top: 10px;
    font-size: 1em;
    .label{
      width: 130px;
      color: #555;
      padding-right: 20px;
    }
    .value{
      text-align: right;
      width: calc(100% - 150px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Form.vue